import colors from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/colors.json';
import styled from 'styled-components';

type SelectColorByConfigStatusProps = {
  value?: string;
  onChange?: (value: string) => void;
  onSelectColor?: (value: string) => void;
};

const SelectColorByConfigStatus = ({ value: activeId, onChange, onSelectColor }: SelectColorByConfigStatusProps) => {
  const handleChangeColor = (id: string) => {
    onChange?.(id);
    onSelectColor?.(id);
  };

  return (
    <Container>
      <ThemeContainer>
        <div className='theme-list'>
          {colors.map((item, index) => (
            <div
              key={index}
              className={`${activeId === item.id ? 'theme-item-selected' : ''}`}
              onClick={() => handleChangeColor(item.id)}
            >
              <div
                className='theme-item'
                style={{ background: item.fill, border: `1px solid ${item.stroke}` }}
              />
            </div>
          ))}
        </div>
      </ThemeContainer>
    </Container>
  );
};

export default SelectColorByConfigStatus;

const Container = styled.div`
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ThemeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  .title {
    color: #505050;
    font-size: 24px;
    font-weight: 600;
  }
  .theme-list {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 8px;
    width: 100%;
  }
  .theme-item {
    cursor: pointer;
    border: 1px solid #adadad;
    box-sizing: border-box;
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 4px;
    background: #fff;
  }
  .theme-item-selected {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #dc5500;
    background: #dc5500;
  }
`;
